/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import {
  Typography,
  FormLabelStyled,
  FormSelectStyled,
  FormTextStyled,
} from '../styled'

function SelectInput({
  name,
  label,
  placeholder,
  helperText,
  required,
  options,
  disabled,
  ...rest
}) {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <div className="mb-2">
          <FormLabelStyled>
            <Typography size="12px">
              {label}
              {required && <span className="text-danger">*</span>}
            </Typography>
          </FormLabelStyled>
          <FormSelectStyled
            disabled={disabled}
            isInvalid={!!fieldState.error}
            onChange={field.onChange}
            value={field.value}
            placeholder={placeholder}
            {...rest}
          >
            <option value={null} className="d-none">
              {null}
            </option>
            {options.map((option) => (
              <option
                key={option.label}
                value={option.value}
                style={{ fontSize: '12px' }}
              >
                {option.label}
              </option>
            ))}
          </FormSelectStyled>
          <FormTextStyled isError={!!fieldState.error}>
            {fieldState.error ? fieldState.error.message : helperText}
          </FormTextStyled>
        </div>
      )}
    />
  )
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.any.isRequired,
    }),
  ),
  disabled: PropTypes.bool,
}

SelectInput.defaultProps = {
  disabled: false,
  placeholder: '',
  helperText: '',
  required: false,
  options: [{ value: '', label: '' }],
}
export default SelectInput
